// src/components/layout/AppLayout.tsx — Site officiel Vanessa
// L'en-tête et le pied de page sont désormais fournis par SiteLayout
// (voir router/AppRouter.tsx) : ce composant ne fait plus que passer le contenu.
export const AppLayout = ({ children }: { children: React.ReactNode }) => <>{children}</>;
